import React from 'react';
import PropTypes from 'prop-types';
import {Space} from 'antd';
import IconWrapper from '../IconWrapper';
import {Unlock2Icon} from '../../icons';
import {transactionsHelpers} from '../../utils/helpers';
// Import from the hook's own file, NOT the ../../hooks barrel: this component is
// pulled in by expenses.helpers (inside the utils/helpers barrel), and importing
// the hooks barrel here closes a circular dependency (hooks -> actions/components
// -> expenses.helpers -> this component) that crashes the app at startup.
import {useObPaymentMethodInfo} from '../../hooks/banking/useObBankName';

// Renders an open banking expense payment method as an icon + (last-4 IBAN,
// bank name) label that links to the owning account's tab. Subscribes to the
// stored OB payment method options so the account link resolves reactively once
// they load (the options are fetched asynchronously on app start).
const ObPaymentMethodCell = ({obPaymentMethod, nameSymbolsLength = 9}) => {
  // Resolve the owning account (for the deep link) and the latest bank name (the
  // stored bank_name can be stale) in one memoized pass over the OB state.
  const {accountId, bankName} = useObPaymentMethodInfo(obPaymentMethod);

  if (!obPaymentMethod) return null;

  const value = transactionsHelpers.getObAccountNumberWithLink({
    obPaymentMethod: {...obPaymentMethod, bank_name: bankName},
    accountId,
    nameSymbolsLength,
  });

  return (
    <Space size={4} align='center' className='d-flex d-flex-child'>
      <IconWrapper>{<Unlock2Icon />}</IconWrapper>
      <span className={`d-inline-flex ${accountId ? ' active-link' : ''} no-wrap`}>{value}</span>
    </Space>
  );
};

ObPaymentMethodCell.propTypes = {
  nameSymbolsLength: PropTypes.number,
  obPaymentMethod: PropTypes.shape({
    id: PropTypes.string,
    account_id: PropTypes.string,
    bank_name: PropTypes.string,
    iban: PropTypes.string,
  }),
};

export default ObPaymentMethodCell;
